import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';

import BuyFragment from './BuyFragment';
import SellFragment from './SellFragment';
import Tabs from 'components/Tabs';
import PortfolioOverview from './PortfolioOverview';
import { getCurrency } from 'state/exchange/selectors';

if (process.env.NODE_ENV !== 'test') {
  require('./QuickTrade.scss');
}

class QuickTrade extends Component {
  state = {
    expanded: false,
    showQuickTrade: false,
    windowWidth: window.innerWidth,
  };

  constructor(props) {
    super(props);

    this.expandToFullWidth = this.expandToFullWidth.bind(this);
  }

  handleResize() {
    this.setState({ windowWidth: window.innerWidth });
  }

  clearTradeForm() {
    window.location.reload();
  }

  componentDidMount() {
    window.addEventListener('resize', () => this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this.handleResize);
  }

  expandToFullWidth(expanded = true) {
    // Allow some time for animation
    setTimeout(() => this.setState({ expanded }));
  }

  toggleQuickTrade() {
    this.setState({ showQuickTrade: !this.state.showQuickTrade });
  }

  render() {
    const { windowWidth } = this.state;
    const link = (
      <Link className="buttonize-on-small" to="/orders/new">
        Avansert
      </Link>
    );

    const isMobile = windowWidth < 767;

    return (
      <div>
        {isMobile ? (
          <button
            type="button"
            className="toggle-quick-trade"
            onClick={() => this.toggleQuickTrade()}
          >
            Hurtighandel
          </button>
        ) : null}

        <div
          className={classNames(
            'QuickTrade',
            !this.state.expanded && 'small',
            isMobile && !this.state.showQuickTrade ? 'hide-quick-trade' : null,
          )}
        >
          <Tabs tabs={['Kjøp', 'Selg', link]}>
            <BuyFragment
              expandToFullWidth={this.expandToFullWidth}
              user={this.props.user}
              key={this.props.currency}
              clearTradeForm={this.clearTradeForm}
            />
            <SellFragment
              expandToFullWidth={this.expandToFullWidth}
              user={this.props.user}
              key={this.props.currency}
              clearTradeForm={this.clearTradeForm}
            />
            {link}
          </Tabs>
          <PortfolioOverview />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { user: state.user, currency: getCurrency(state) };
}

export { QuickTrade };
export default connect(mapStateToProps)(QuickTrade);
